"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyLayoutRequiredServices = void 0;
var _configurationManager = require("@ori/configuration-manager");
const emptyLayoutRequiredServices = exports.emptyLayoutRequiredServices = [_configurationManager.serviceSchema.Enum.globalApi, _configurationManager.serviceSchema.Enum.clientApps, _configurationManager.serviceSchema.Enum.identity, _configurationManager.serviceSchema.Enum.staticApi];
